/**
 * MN header menu — desktop hover open/close (top-level + nested flyouts).
 * Loads AFTER stock details-disclosure.js. Do not edit details-disclosure.js.
 * On Studio update: keep this file; replace details-disclosure.js from upstream.
 */
(function () {
  const CLOSE_DELAY_MS = 180;
  const DESKTOP_HOVER_MQ = '(min-width: 990px) and (hover: hover)';

  function isDesktopHover() {
    return window.matchMedia(DESKTOP_HOVER_MQ).matches;
  }

  function enhanceHeaderMenu(Ctor) {
    const proto = Ctor.prototype;
    if (proto.__mnHoverEnhanced) return;
    proto.__mnHoverEnhanced = true;

    const originalOnToggle = proto.onToggle;

    proto.onToggle = function onToggle() {
      if (typeof originalOnToggle === 'function') originalOnToggle.call(this);
      else if (this.header) {
        this.header.preventHide = this.mainDetailsToggle.open;
      }
    };

    proto.__mnIsDesktopHover = function () {
      return isDesktopHover();
    };

    proto.__mnClearCloseTimeout = function () {
      if (this.__mnCloseTimeout) {
        clearTimeout(this.__mnCloseTimeout);
        this.__mnCloseTimeout = null;
      }
    };

    proto.__mnOpen = function () {
      this.mainDetailsToggle.setAttribute('open', '');
      this.mainDetailsToggle.querySelector('summary')?.setAttribute('aria-expanded', 'true');
      if (this.header) this.header.preventHide = true;
    };

    proto.__mnOnMouseEnter = function () {
      if (!this.__mnIsDesktopHover()) return;
      this.__mnClearCloseTimeout();
      this.__mnOpen();
    };

    proto.__mnOnMouseLeave = function () {
      if (!this.__mnIsDesktopHover()) return;
      this.__mnClearCloseTimeout();
      this.__mnCloseTimeout = setTimeout(() => {
        this.querySelectorAll('details.mn-submenu__nest[open]').forEach((nest) => {
          nest.removeAttribute('open');
          nest.querySelector('summary')?.setAttribute('aria-expanded', 'false');
        });
        this.close();
        if (this.header) this.header.preventHide = false;
        this.__mnCloseTimeout = null;
      }, CLOSE_DELAY_MS);
    };

    // On desktop hover menus, summary click must not toggle closed.
    proto.__mnOnSummaryClick = function (event) {
      if (!this.__mnIsDesktopHover()) return;
      event.preventDefault();
      this.__mnOpen();
    };

    proto.__mnOnNestEnter = function (event) {
      if (!this.__mnIsDesktopHover()) return;
      const nest = event.currentTarget;
      if (!(nest instanceof HTMLDetailsElement)) return;

      this.querySelectorAll('details.mn-submenu__nest[open]').forEach((openNest) => {
        if (openNest === nest) return;
        openNest.removeAttribute('open');
        openNest.querySelector('summary')?.setAttribute('aria-expanded', 'false');
      });

      nest.setAttribute('open', '');
      nest.querySelector('summary')?.setAttribute('aria-expanded', 'true');
    };

    proto.__mnOnNestLeave = function (event) {
      if (!this.__mnIsDesktopHover()) return;
      const nest = event.currentTarget;
      if (!(nest instanceof HTMLDetailsElement)) return;
      nest.removeAttribute('open');
      nest.querySelector('summary')?.setAttribute('aria-expanded', 'false');
    };

    proto.__mnOnNestSummaryClick = function (event) {
      if (!this.__mnIsDesktopHover()) return;
      event.preventDefault();
      const nest = event.currentTarget.closest('details.mn-submenu__nest');
      if (!(nest instanceof HTMLDetailsElement)) return;
      nest.setAttribute('open', '');
      nest.querySelector('summary')?.setAttribute('aria-expanded', 'true');
    };

    proto.__mnBindHover = function () {
      if (this.__mnHoverBound) return;
      this.__mnHoverBound = true;

      this.__mnOnMouseEnterHandler = this.__mnOnMouseEnter.bind(this);
      this.__mnOnMouseLeaveHandler = this.__mnOnMouseLeave.bind(this);
      this.__mnOnSummaryClickHandler = this.__mnOnSummaryClick.bind(this);

      this.addEventListener('mouseenter', this.__mnOnMouseEnterHandler);
      this.addEventListener('mouseleave', this.__mnOnMouseLeaveHandler);

      const topSummary = this.mainDetailsToggle?.querySelector(':scope > summary');
      topSummary?.addEventListener('click', this.__mnOnSummaryClickHandler);

      this.__mnNestCleanups = [];
      this.querySelectorAll('details.mn-submenu__nest').forEach((nest) => {
        const onEnter = (event) => this.__mnOnNestEnter(event);
        const onLeave = (event) => this.__mnOnNestLeave(event);
        const onSummaryClick = (event) => this.__mnOnNestSummaryClick(event);
        const summary = nest.querySelector(':scope > summary');
        nest.addEventListener('mouseenter', onEnter);
        nest.addEventListener('mouseleave', onLeave);
        summary?.addEventListener('click', onSummaryClick);
        this.__mnNestCleanups.push(() => {
          nest.removeEventListener('mouseenter', onEnter);
          nest.removeEventListener('mouseleave', onLeave);
          summary?.removeEventListener('click', onSummaryClick);
        });
      });
    };

    proto.__mnUnbindHover = function () {
      if (!this.__mnHoverBound) return;
      this.removeEventListener('mouseenter', this.__mnOnMouseEnterHandler);
      this.removeEventListener('mouseleave', this.__mnOnMouseLeaveHandler);
      this.mainDetailsToggle
        ?.querySelector(':scope > summary')
        ?.removeEventListener('click', this.__mnOnSummaryClickHandler);
      this.__mnNestCleanups?.forEach((fn) => fn());
      this.__mnNestCleanups = [];
      this.__mnClearCloseTimeout();
      this.__mnHoverBound = false;
    };

    const originalConnected = proto.connectedCallback;
    proto.connectedCallback = function connectedCallback() {
      if (typeof originalConnected === 'function') originalConnected.call(this);
      this.__mnBindHover();
    };

    const originalDisconnected = proto.disconnectedCallback;
    proto.disconnectedCallback = function disconnectedCallback() {
      this.__mnUnbindHover();
      if (typeof originalDisconnected === 'function') originalDisconnected.call(this);
    };
  }

  function bindExisting() {
    document.querySelectorAll('header-menu').forEach((el) => {
      if (typeof el.__mnBindHover === 'function') el.__mnBindHover();
    });
  }

  if (customElements.get('header-menu')) {
    enhanceHeaderMenu(customElements.get('header-menu'));
    bindExisting();
  } else {
    customElements.whenDefined('header-menu').then(() => {
      enhanceHeaderMenu(customElements.get('header-menu'));
      bindExisting();
    });
  }
})();
